import React, { useEffect, useState, useContext, useRef } from "react";
import {
	Button,
	Card,
	CardBody,
	Col,
	Form,
	Pagination,
	Row,
	Table,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";
import { LoadingContext } from "../../App";
import { IoRemoveCircle } from "react-icons/io5";
import { IoFilter } from "react-icons/io5";
import ActionButton from "../../componets/ActionButon";
import Header from "../../componets/Header";
import { FaCircleArrowLeft } from "react-icons/fa6";

const sort = [
	"name",
	"symbol",
	"date_added",
	"market_cap",
	"market_cap_strict",
	"price",
	"circulating_supply",
	"total_supply",
	"max_supply",
	"num_market_pairs",
	"volume_24h",
	"percent_change_1h",
	"percent_change_24h",
	"percent_change_7d",
	"market_cap_by_total_supply_strict",
	"volume_7d",
	"volume_30d",
];
const sort_dir = ["asc", "desc"];
const cryptocurrency_type = ["all", "coins", "tokens"];
const tag = ["all", "defi", "filesharing"];
const aux = [
	"num_market_pairs",
	"cmc_rank",
	"date_added",
	"tags",
	"platform",
	"max_supply",
	"circulating_supply",
	"total_supply",
	"market_cap_by_total_supply",
	"volume_24h_reported",
	"volume_7d",
	"volume_7d_reported",
	"volume_30d",
	"volume_30d_reported",
	"is_market_cap_included_in_calc",
]; //multi select

const buttonSpinnerId = Math.random();

const Coins = props => {
	const {
		addPageSpinner,
		removePageSpinner,
		addButtonSpinner,
		removeButtonSpinner,
	} = useContext(LoadingContext);
	const navaigate = useNavigate();
	const [topCoins, setTopCoins] = useState([]);
	const [isShowFilter, setIsShowFilter] = useState("");

	const [currentPage, setCurrentPage] = useState(1);
	const [hasMorePages, setHasMorePages] = useState(true);
	const [disabled, setDisabled] = useState(false);

	const [filter, setFilter] = useState({
		start: 1, //num
		limit: 100, //num
		price_min: null, //num
		price_max: null, //num
		market_cap_min: null, //num
		market_cap_max: null, //num
		volume_24h_min: null, //num
		volume_24h_max: null, //num
		circulating_supply_min: null, //num
		circulating_supply_max: null, //num
		percent_change_24h_min: null, //num
		percent_change_24h_max: null, //num
		convert: "", //str
		convert_id: "", //???
		sort: "", //select
		sort_dir: "", //select
		cryptocurrency_type: "", //select
		tag: "", //select
		aux: [], //multi select
	});

	const drawerRef = useRef(null);

	useEffect(() => {
		setTimeout(() => {
			if (!isShowFilter) return;
		}, 100);

		const handleClickOutside = event => {
			if (drawerRef.current && !drawerRef.current.contains(event.target)) {
				// debugger;
				event.stopPropagation();
				event.preventDefault();
				setIsShowFilter(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		// cleanup
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isShowFilter]);

	useEffect(() => {
		getTopCoins(filter);
	}, []);

	const handleChange = event => {
		const { value, name } = event.target;
		setFilter(prevFilter => ({
			...prevFilter,
			[name]: value,
		}));
	};

	const handleSelectOptionChange = (event, fieldName) => {
		const { value } = event.target;
		setFilter(prevFilter => ({
			...prevFilter,
			[fieldName]: value,
		}));
	};

	const handleAuxChange = (event, fieldName) => {
		const { value } = event.target;
		if (filter.aux.includes(value)) {
			return false;
		}
		setFilter(prevFilter => ({
			...prevFilter,
			[fieldName]: [...filter.aux, value],
		}));
	};

	const deleteAux = index => {
		let newAux = filter.aux.filter((_, idx) => idx !== index);
		setFilter(prevFilter => ({
			...prevFilter,
			aux: newAux,
		}));
	};

	const getTopCoins = (filter, isChange = false) => {
		const spinnerId = Math.random();
		setDisabled(true);
		let data = { ...filter };
		if (!data.start) {
			data = { ...data, start: 1 };
		}
		if (!data.limit) {
			data = { ...data, limit: 100 };
		}
		addPageSpinner(spinnerId);
		ApiService.getTopCoins(data)
			.then(response => {
				if (response && response.data) {
					if (isChange) {
						setCurrentPage(1);
					}
					setTopCoins(response.data);
					setIsShowFilter("");
					if (data.limit && response.data.length < data.limit) {
						setHasMorePages(false);
					}
					// scrollToTop();
				} else {
					setTopCoins([]);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				removePageSpinner(spinnerId);
				removeButtonSpinner(buttonSpinnerId);
				setDisabled(false);
				setIsShowFilter(false);
				setTimeout(() => {
					scrollToCurrentBlockPosition("table");
				}, 500);
			});
	};

	const onSubmit = event => {
		event && event.preventDefault();
		addButtonSpinner(buttonSpinnerId);
		setCurrentPage(0); // Сброс на первую страницу при фильтрации
		getTopCoins(filter, true);
	};

	const scrollToCurrentBlockPosition = id => {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
		}
	};

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	const handlePageChange = pageNumber => {
		setCurrentPage(pageNumber);
		setFilter(prevFilter => ({
			...prevFilter,
			start: (pageNumber - 1) * prevFilter.limit + 1,
		}));
		getTopCoins({ ...filter, start: (pageNumber - 1) * filter.limit + 1 });
	};

	return (
		<div>
			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0">Coins</h4>
					</div>

					<Button
						variant="primary"
						size="sm"
						className="px-3 d-flex align-items-center"
						onClick={e => {
							setIsShowFilter(!isShowFilter);
						}}>
						<IoFilter
							className={`me-2 transition ${isShowFilter ? "rotate-180" : ""}`}
						/>
						{isShowFilter ? "Hide Filter" : "Show Filter"}
					</Button>
				</div>
			</Header>

			<Row className="mb-5 ">
				{/* <div
					className="filter_leyaut"
					onClick={e => {
						e.preventDefault();
						e.stopPropagation();
					}}
				/> */}
				<Col sm={12}>
					{/* FILTER */}
					<div
						ref={drawerRef}
						onClick={e => e.stopPropagation()}
						className={`filter-drawer ${
							isShowFilter ? "drawer-open" : "drawer-close"
						}`}>
						<div className="filter-header d-flex justify-content-between">
							<span>Filters</span>
							<Button
								variant="outline-secondary"
								size="sm"
								onClick={() => setIsShowFilter(false)}>
								✕
							</Button>
						</div>

						<Form onSubmit={onSubmit} className="filter-body">
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="start">
									Start
								</Form.Label>
								<Form.Control
									id="start"
									type="number"
									value={filter.start || ""}
									onChange={handleChange}
									name="start"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="limit">
									Limit
								</Form.Label>
								<Form.Control
									id="limit"
									type="number"
									value={filter.limit || ""}
									onChange={handleChange}
									name="limit"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="price_min">
									Price Minimum{" "}
								</Form.Label>
								<Form.Control
									id="price_min"
									type="number"
									value={filter.price_min || ""}
									onChange={handleChange}
									name="price_min"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="price_max">
									Price Maximum{" "}
								</Form.Label>
								<Form.Control
									id="price_max"
									type="number"
									value={filter.price_max || ""}
									onChange={handleChange}
									name="price_max"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="market_cap_min">
									Minimum Capitalization
								</Form.Label>
								<Form.Control
									id="market_cap_min"
									type="number"
									value={filter.market_cap_min || ""}
									onChange={handleChange}
									name="market_cap_min"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="market_cap_max">
									Maximum Capitalization
								</Form.Label>
								<Form.Control
									id="market_cap_min"
									type="number"
									value={filter.market_cap_max || ""}
									onChange={handleChange}
									name="market_cap_max"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="volume_24h_min">
									Minimum Volume 24h
								</Form.Label>
								<Form.Control
									id="volume_24h_min"
									type="number"
									value={filter.volume_24h_min || ""}
									onChange={handleChange}
									name="volume_24h_min"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="volume_24h_max">
									Maximum Volume 24h
								</Form.Label>
								<Form.Control
									id="volume_24h_max"
									type="number"
									value={filter.volume_24h_max || ""}
									onChange={handleChange}
									name="volume_24h_max"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="circulating_supply_min">
									Minimum Circulating Supply
								</Form.Label>
								<Form.Control
									id="circulating_supply_min"
									type="number"
									value={filter.circulating_supply_min || ""}
									onChange={handleChange}
									name="circulating_supply_min"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="circulating_supply_max">
									Maximum Circulating Supply
								</Form.Label>
								<Form.Control
									id="circulating_supply_max"
									type="number"
									value={filter.circulating_supply_max || ""}
									onChange={handleChange}
									name="circulating_supply_max"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label htmlFor="percent_change_24h_min" className="mb-0">
									Minimum Percent Change 24h
								</Form.Label>
								<Form.Control
									id="percent_change_24h_min"
									type="number"
									value={filter.percent_change_24h_min || ""}
									onChange={handleChange}
									name="percent_change_24h_min"
								/>
							</Form.Group>
							<Form.Group className="mb-0">
								<Form.Label className="mb-0" htmlFor="percent_change_24h_max">
									Maximum Percent Change 24h
								</Form.Label>
								<Form.Control
									id="percent_change_24h_max"
									type="number"
									value={filter.percent_change_24h_max || ""}
									onChange={handleChange}
									name="percent_change_24h_max"
								/>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label className="mb-0" htmlFor="convert">
									Convert
								</Form.Label>
								<Form.Control
									id="convert"
									type="text"
									value={filter.convert || ""}
									onChange={handleChange}
									name="convert"
								/>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Sort</Form.Label>
								<Form.Select
									onChange={event => handleSelectOptionChange(event, "sort")}>
									<option value={null}>{filter.sort ? filter.sort : ""}</option>
									{sort.map((key, index) => (
										<option name="sort" key={index} value={key}>
											{key}
										</option>
									))}
								</Form.Select>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Sort Dir</Form.Label>
								<Form.Select
									onChange={event =>
										handleSelectOptionChange(event, "sort_dir")
									}>
									<option value={null}>
										{filter.sort_dir ? filter.sort_dir : ""}
									</option>
									{sort_dir.map((key, index) => (
										<option key={index} value={key}>
											{key}
										</option>
									))}
								</Form.Select>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Cryptocurrency Type</Form.Label>
								<Form.Select
									onChange={event =>
										handleSelectOptionChange(event, "cryptocurrency_type")
									}>
									<option value={null}>
										{filter.cryptocurrency_type
											? filter.cryptocurrency_type
											: ""}
									</option>
									{cryptocurrency_type.map((key, index) => (
										<option key={index} value={key}>
											{key}
										</option>
									))}
								</Form.Select>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Tag</Form.Label>
								<Form.Select
									onChange={event => handleSelectOptionChange(event, "tag")}>
									<option value={null}>{filter.tag ? filter.tag : ""}</option>
									{tag.map((key, index) => (
										<option key={index} value={key}>
											{key}
										</option>
									))}
								</Form.Select>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Aux</Form.Label>
								<Form.Select onChange={event => handleAuxChange(event, "aux")}>
									<option value={null}>Choose...</option>
									{aux.map((key, index) => {
										if (filter.aux.includes(key)) {
											return;
										} else {
											return (
												<option key={index} value={key}>
													{key}
												</option>
											);
										}
									})}
								</Form.Select>
							</Form.Group>
							{filter.aux && filter.aux.length ? (
								<div>
									<div className="d-flex flex-wrap gap-1">
										{filter.aux.map((item, index) => {
											return (
												<div
													key={index}
													className="border rounded py-2 px-3 d-flex bg-white">
													{item}
													<Button
														onClick={() => {
															deleteAux(index);
														}}
														variant="outline-danger"
														size="sm"
														className="d-flex ms-2">
														<IoRemoveCircle />
													</Button>
												</div>
											);
										})}
									</div>
								</div>
							) : null}

							<div className="d-flex justify-content-end mt-4 gap-2">
								<ActionButton
									buttonSpinnerId={buttonSpinnerId}
									buttonName="Reset"
									type="button"
									buttonClassName="btn-danger"
									cb={() => {
										setFilter({
											start: 1,
											limit: 100,
											price_min: null,
											price_max: null,
											market_cap_min: null,
											market_cap_max: null,
											volume_24h_min: null,
											volume_24h_max: null,
											circulating_supply_min: null,
											circulating_supply_max: null,
											percent_change_24h_min: null,
											percent_change_24h_max: null,
											convert: "",
											convert_id: "",
											sort: "",
											sort_dir: "",
											cryptocurrency_type: "",
											tag: "",
											aux: [],
										});
										getTopCoins(
											{
												start: 1,
												limit: 100,
												price_min: null,
												price_max: null,
												market_cap_min: null,
												market_cap_max: null,
												volume_24h_min: null,
												volume_24h_max: null,
												circulating_supply_min: null,
												circulating_supply_max: null,
												percent_change_24h_min: null,
												percent_change_24h_max: null,
												convert: "",
												convert_id: "",
												sort: "",
												sort_dir: "",
												cryptocurrency_type: "",
												tag: "",
												aux: [],
											},
											true,
										);
									}}
								/>
								<ActionButton
									buttonSpinnerId={buttonSpinnerId}
									buttonName="Apply"
								/>
							</div>
						</Form>
					</div>

					{/* TABLE */}
					{topCoins?.length > 0 && (
						<Card className="mt-4">
							<CardBody>
								<Table responsive hover>
									<thead>
										<tr>
											<th>#</th>
											<th>Symbol</th>
											<th>Name</th>
											<th>Price</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										{topCoins.map((item, index) => (
											<tr
												key={index}
												// onClick={() => {

												// 	navaigate(`/network-analyze?symbol=${item.symbol}`);
												// }}
											>
												<td>{index + 1}</td>
												<td>{item.symbol}</td>
												<td>{item.name}</td>
												<td>{Object.values(item.quote || {})[0]?.price}</td>
												<td>
													<div className="d-flex gap-2">
														<Link
															to={`/network-analyze?symbol=${item.symbol}`}
															type="button"
															className="btn btn-success btn-sm px-3">
															View
														</Link>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</Table>
							</CardBody>
						</Card>
					)}
				</Col>
			</Row>
		</div>
	);
};

export default Coins;
